import { Box, HStack } from '@chakra-ui/react';
import { useRef, type FC } from 'react';

import { CollectionFilter } from '$/components/core/Collection/CollectionFilter';
import { CollectionViewOptionSelector } from '$/components/core/Collection/CollectionViewOptionSelector';
import { BaseCollectionLayout } from '$/pages/DashboardPages/pages/Collection/pages/layouts/BaseCollectionLayout';
import { type MaterialType } from '$/services/usecases/materials/mapper/materials';

interface Props {
  materialType: MaterialType;
}

export const CollectionCategoryPage: FC<Props> = ({ materialType }) => {
  const sectionRef = useRef<HTMLDivElement>(null);

  return (
    <BaseCollectionLayout materialType={materialType} ref={sectionRef}>
      <HStack justify='space-between' w='full' mb='4'>
        <Box w='full' maxW={{ base: 'full', mobile: '85%' }}>
          <CollectionFilter sectionRef={sectionRef} />
        </Box>
        <CollectionViewOptionSelector />
      </HStack>
    </BaseCollectionLayout>
  );
};
